import script from "./StudentSkillGraphPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentSkillGraphPage.vue?vue&type=script&setup=true&lang=ts"

import "./StudentSkillGraphPage.vue?vue&type=style&index=0&id=0b246707&scoped=true&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b246707"]])

export default __exports__